const daysToNaturalLanguage = (date: Date) => {
    const today = new Date()
    const delta_time = today.getTime() - date.getTime()
    const delta_days = Math.floor(delta_time / (1000 * 3600 * 24))

    if (delta_days === 0) return 'Hoy'
    else if (delta_days === 1) return 'Ayer'
    else if (delta_days < 7) return `Hace ${delta_days} días`
    else if (delta_days < 30) {
        const delta_weeks = Math.round(delta_days / 7)

        if (delta_weeks === 4) return 'Hace un mes'
        else return `Hace ${delta_weeks} semana${delta_weeks > 1 ? 's' : ''}`
    } else if (delta_days < 365) {
        const delta_months = Math.round(delta_days / 30)

        if (delta_months === 12) return 'Hace un año'
        else return `Hace ${delta_months} mes${delta_months > 1 ? 'es' : ''}`
    } else return 'Hace más de un año'
}

export { daysToNaturalLanguage }
